'use client';

import { useEffect, useRef, useState } from 'react';

import { AnnouncementBar } from '@gds/AnnouncementBar/AnnouncementBar';
import { Confetti } from '@gds/Icons/Paths/Confetti';
import { componentViewedToEvent } from '@tracking/Schemas/ComponentViewed/ComponentViewedToEvent';
import { trackCustomEvent } from '@tracking/Utils/TrackCustomEvent';

import type { LegacyBrand } from '../../Utils/ResolveLegacyBrand/ResolveLegacyBrand.types';

import styles from './LegacyBrandBanner.module.css';

type BannerCopy = { announcement: string; ctaText: string; ctaHref: string };

export const LegacyBrandBanner = ({
  brand,
  bannerCopy,
}: {
  brand: LegacyBrand | null;
  bannerCopy: BannerCopy | null;
}) => {
  const tracked = useRef(new Set<string>());
  const [visible, setVisible] = useState(() => Boolean(bannerCopy));

  useEffect(() => {
    if (!brand || !bannerCopy) return;

    if (!tracked.current.has(brand)) {
      tracked.current.add(brand);
      const event = componentViewedToEvent({
        compType: 'legacy_brand_message_view',
        compWording: bannerCopy.announcement,
        compCategory: brand,
        compLocation: window.location.pathname,
        targetUrl: window.location.href,
      });
      trackCustomEvent({ event, context: [] });
    }
  }, [brand, bannerCopy]);

  if (!visible || !bannerCopy) return null;

  return (
    <AnnouncementBar icon={<Confetti useStroke fontSize={24} />} onClose={() => setVisible(false)}>
      {bannerCopy.announcement}{' '}
      <a href={bannerCopy.ctaHref} className={styles.link} onClick={() => setVisible(false)}>
        {bannerCopy.ctaText}
      </a>
    </AnnouncementBar>
  );
};
